/**
 * Специальная карточка для демонстрации детальной информации 
 * 
 * Откючены все редактируемые функции
 */
import React from 'react'; 
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, Tabs, message } from 'antd';
import { FileZipOutlined, RollbackOutlined } from '@ant-design/icons'
import { LoadingComponent } from '../../utils/ui'
import { getNameAsset } from '../../components/adms/helper';
import IndividualData from '../../components/subject/IndividualData';
import { VocabsRepository, VocabsIndividual, ModelViews, RdfTriplet} from '../../redux';
import { DetailLinkScheme } from '../../components/adms/DetailLinkCard';
import ViewsProxy from '../models/ViewsProxy';
import ExportIndividual from '../../components/export/ExportIndividual';

const ButtonGroup = Button.Group;
const { confirm } = Modal;
const { TabPane } = Tabs;

const AssetTitle = names => {
    const single = names.length = 1;
    return (single)? names[0]: <span>names.map(name => <p>{name}</p>)</span>;
}

const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} visible={true} title="Детальная информация" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, style: {dispaly: "none" }}}>
        <DetailLinkScheme triplet={selected} factory={factory}/>
	  </Modal>
}

const decodeIRIParams = router =>{
  const params = router?.params || {};
  const rawSubject = params.id || params["*"];
  return rawSubject ? decodeURIComponent(rawSubject) : undefined;  
}


/** Отображаются данные по заданному IRI субъекта. */
class SubjectCard extends React.Component {
  
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false, 			  //Флаг загрузки
      operation: "view",    //Текущая операция над карточкой
      detail: undefined,    //Элемент, для которого требуется получение дополнительной информацией
      exportCard: false,    //Флаг, для отображения далога c экспортом карточки
      views: false,         //Загружены представления содержимого актива
      activeKey: undefined, //Номер активной вкладки
    }
  }
   
  static getDerivedStateFromProps(props, state) {
    if ((decodeIRIParams(props.router)!=props.IRI)||(props.state=="empty") || !props.IRI){
      return {loaded: false, operation: "view", detail: undefined};
    }
    if ((decodeIRIParams(props.router)==props.IRI)||(props.state=="loaded")){
        return { ...state, loaded: true}
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const IRI = decodeIRIParams(this.props.router);
    if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty")){
      Promise.all([
        this.props.onReload(VocabsIndividual, IRI).then(response => {
          this.loadAnonymousNodes(response);
          return response;
        }),
        this.props.onReloadViews(ModelViews, IRI),
      ]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const IRI = decodeIRIParams(this.props.router);

    if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
      this.props.onReload(VocabsIndividual, IRI).then( response => {
        this.loadAnonymousNodes(response);
        this.props.onReloadViews(ModelViews, IRI).then(views => {
          const activeKey = (this.props.location && this.props.location.search && this.props.location.search.indexOf('view=')>0)? "3" : undefined;
          this.setState({views: true, activeKey});
        });
      });
  }

  loadAnonymousNodes(response){    
    const bindings = response && response.results && Array.isArray(response.results.bindings)
      ? response.results.bindings
      : [];

    const nodeIDs = [...new Set(bindings
      .filter(item => item.object && item.object.type === "bnode")
      .map(item => item.object.value))];

    const visited = new Set();
    return Promise.all(nodeIDs.map(nodeID => this.loadNodes(nodeID, 1, visited)))
      .then(results => {
        const loadedNodes = [].concat(...results);
        const nodeContents = loadedNodes.reduce((contents, node) => {
          contents[node.nodeID] = node.bindings;
          return contents;
        }, {});
        const contents = Object.keys(nodeContents).reduce((result, nodeID) => {
          result[nodeID] = this.buildNodeContent(nodeID, nodeContents);
          return result;
        }, {});
        const nodes = [].concat(...Object.values(contents));
        if (nodes.length > 0)
          this.props.onAddNodes(VocabsIndividual, nodes, contents);
        return nodes;
      });
  }

  buildNodeContent(nodeID, nodeContents, parents=new Set()){
    if (parents.has(nodeID))
      return [];

    const nextParents = new Set(parents);
    nextParents.add(nodeID);
    const bindings = nodeContents[nodeID] || [];
    return bindings.map(item => {
      if (!item.object || item.object.type !== "bnode")
        return item;

      return {
        ...item,
        object: {
          ...item.object,
          content: this.buildNodeContent(item.object.value, nodeContents, nextParents),
        },
      };
    });
  }

  loadNodes(nodeID, depth=1, visited=new Set()){
    if (!nodeID || depth > 10 || visited.has(nodeID))
      return Promise.resolve([]);

    visited.add(nodeID);
    return this.props.onLoadNodes(RdfTriplet, nodeID).then(response => {
      const bindings = response && Array.isArray(response.bindings)
        ? response.bindings.map(item => ({
            ...item,
            subject: response.subject || item.subject || item.s,
            predicat: item.predicat || item.p,
            object: item.object || item.o,
          }))
        : [];
      const childNodeIDs = [...new Set(bindings
        .filter(item => item.object && item.object.type === "bnode")
        .map(item => item.object.value))];

      return Promise.all(childNodeIDs.map(childNodeID =>
        this.loadNodes(childNodeID, depth + 1, visited)
      )).then(results => [
        {nodeID, bindings},
        ...[].concat(...results),
      ]);
    });
  }

  callbackSelectTab(key) {
    console.log(key);
    this.setState({activeKey: undefined});
  }
  
  onSelectOperation(e, operation) { 
    e.preventDefault();
    const { IRI, values, lang, factory, onDeleteElement, router} = this.props;
    if (operation=="delete"){
      confirm({ title: 'Удалить выбранный элемент', content: getNameAsset(values, lang), 
        okText: 'Да', okType: 'danger', cancelText: 'Нет',
        onOk() { 
            onDeleteElement(VocabsRepository, IRI)
            .then (result =>{
                console.log("onDeleteElement", result);
                message.success("Запись удалена.");
                if (router)
                    router.navigate("/vocabs");
            })
        },
        onCancel() {},
      });
      return;
    };
    if (operation == "back"){
      if (router) router.navigate("/vocabs");
      return;
    };
    if (operation == "export"){
      this.setState({exportCard: true});
      return;      
    }
    this.setState({operation});
  }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    //console.log("ConceptSchemeCard.js handlers(e, triplet, operation)", triplet, operation, (operation== "inScheme"));
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement) 
      //В триплете приходит {predicat: {…}, object: {…}}
      this.props.onDetailElement(VocabsIndividual, catalog, triplet)
      .then (result =>{
        //console.log("handlers(e, triplet, operation)", result);
        this.setState({detail: triplet});
    });
  }

  cancelOperation(){
    this.setState({detail: undefined, exportCard: false});
  }


  onReload(){
    this.props.onReload(VocabsIndividual, this.props.IRI);
  }

  render() {
    let { loaded, operation, detail, activeKey, exportCard} = this.state;
    const { predicates, values, lang, factory, IRI, vviews, isSignedIn, inGroup, concepts} = this.props;
    const asset_json = {id: IRI};
    //Флаг, что есть представление для отображение содержимого 
    const views = vviews && Array.isArray(vviews.views) && vviews.views.length>0;
    console.log(this); //console.log(lang);
    const assetTitle = AssetTitle(getNameAsset(values, lang));
    return (
      (!loaded? <LoadingComponent />:
        <span>
          <Row>
            <Col className="asset_title" span={24}>{assetTitle}</Col>
          </Row>
          <Row style={{justifyContent: "center"}}>
            <div className="csi_wrapper_content csi_inner_asset" resource={IRI} style={{width: "80%"}}>
                <Row>
                  <Col className="asset_title" span={24} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                      {isSignedIn && inGroup.PowerUser && (
                        <ButtonGroup>
                          <Tooltip placement="top" title={i18n.t('views.adms.export_card')}>
                            <Button icon={<FileZipOutlined />} onClick={(e)=> this.onSelectOperation(e, "export")}/>
                          </Tooltip>                              
                        </ButtonGroup>
                      )}
                    </Col>
                </Row>
                <Row id="IndividualData">
                    <Col className="assetCardTable" span={24}>
                      <IndividualData
                        operation={operation} factory={factory} 
                        handlers={(e,t,o)=> this.handlers(e,t,o)} onReload={() => this.onReload()}/> 
                    </Col>
                </Row>
              {detail && showViewDetail(this.formRef, detail, factory, ()=>this.cancelOperation(), ()=>this.cancelOperation())}
              { exportCard && <ExportIndividual open={true} onClose={()=> this.cancelOperation()} IRI={IRI}/>}
            </div>            
      </Row>
      </span>
      )
    )
  }
}

export default SubjectCard;
